"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactCollapsible = _interopRequireDefault(require("react-collapsible"));

var _he = _interopRequireDefault(require("he"));

var _List = require("../List");

var _ThemeProvider = require("../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FilterMenu =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterMenu, _Component);

  function FilterMenu() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FilterMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FilterMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "header", function (filter) {
      var rightActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return _react["default"].createElement(_List.ListItem, {
        key: "header-".concat(filter.name),
        caption: filter.name,
        rightActions: rightActions,
        className: _this.props.theme.heading
      });
    });

    _defineProperty(_assertThisInitialized(_this), "options", function (filter) {
      return filter.options.map(function (option) {
        var item = null;
        var key = option.id || option.name;

        switch (filter.type) {
          case 'select':
            item = _react["default"].createElement(_List.ListItem, {
              legend: _he["default"].decode(option.name),
              onClick: function onClick() {
                return filter.onSelect(option);
              },
              className: _this.props.theme.option,
              selectable: true,
              selected: option.selected,
              key: key
            });
            break;

          case 'checkbox':
            item = _react["default"].createElement(_List.ListCheckbox, {
              legend: _he["default"].decode(option.name),
              onChange: function onChange() {
                return filter.onSelect(option, !option.selected);
              },
              className: _this.props.theme.option,
              checked: option.selected,
              disabled: option.available === false,
              key: key
            });
            break;
        }

        return item;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterList", function (filter) {
      if (filter.collapsible === false) {
        if (!filter.name) {
          return _this.options(filter);
        }

        return [_this.header(filter), _this.options(filter)];
      }

      return _this.collapsible(filter);
    });

    _defineProperty(_assertThisInitialized(_this), "filter", function (filter) {
      return _react["default"].createElement("div", {
        key: filter.name
      }, _this.filterList(filter));
    });

    _defineProperty(_assertThisInitialized(_this), "collapsible", function (filter) {
      return _react["default"].createElement(_reactCollapsible["default"], {
        transitionTime: 200,
        open: !!filter.open,
        trigger: _this.header(filter, [_react["default"].createElement("span", {
          key: "closed-action-".concat(filter.name)
        }, "+")]),
        triggerWhenOpen: _this.header(filter, [_react["default"].createElement("span", {
          key: "opened-action-".concat(filter.name)
        }, "-")])
      }, _this.options(filter));
    });

    return _this;
  }

  _createClass(FilterMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var filters = this.props.filters.reduce(function (prev, curr) {
        if (_this2.props.useDivider && prev.length !== 0) prev.push(_react["default"].createElement(_List.ListDivider, {
          key: "divider-".concat(curr.name)
        }));
        prev.push(_this2.filter(curr));
        return prev;
      }, []);
      return _react["default"].createElement("div", {
        className: this.props.theme.menu
      }, _react["default"].createElement(_List.List, {
        selectable: true
      }, filters));
    }
  }]);

  return FilterMenu;
}(_react.Component);

_defineProperty(FilterMenu, "defaultProps", {
  useDivider: true
});

var _default = (0, _ThemeProvider.applyTheme)('FilterMenu', FilterMenu);

exports["default"] = _default;